<template>
  <nav class="pagination-1" v-if="paginationComponentStatus">
    <ul v-if="totalPages > 0" class="pagination" dir="rtl">
      <li class="page-item">
        <a class="page-link" v-if="currentPage > 1" @click="currentPage-=1" href="javascript:void(0)" aria-label="قبلی">
          <span aria-hidden="true">&laquo;</span>
        </a>
      </li>
      <li v-for="item in pagesList" @click="currentPage=item" class="page-item" :class="{'active':item== currentPage}">
        <a class="page-link" href="javascript:void(0)">{{ item }}</a>
      </li>

      <li class="page-item" dir="rtl">
        <a class="page-link" v-if="currentPage != totalPages" @click="currentPage+=1" href="javascript:void(0)"
           aria-label="بعدی">
          <span aria-hidden="true">&raquo;</span>
        </a>
      </li>
    </ul>
  </nav>
</template>

<script>
export default {
  name: "Paginate1",
  data() {
    return {
      currentPage: 1
    }
  },
  props: {
    meta: {
      default: []
    },
    onChangePage: {},
    infinityLoading: {
      default: false
    },
    enableScrollTopOnPageChange: {
      default: true
    }
  },
  computed: {
    totalPages() {
      return this.meta.last_page
    },
    pagesList() {
      let pages = this.totalPages;
      pages = pages === 0 || isNaN(pages) ? 1 : pages + 1;

      const copyCurrentPage = this.currentPage;
      let currentPage = copyCurrentPage

      if (currentPage > pages) {
        return 1
      }

      currentPage = (currentPage - 1) > 0 ? currentPage - 1 : currentPage

      let pageRange = this.range(currentPage, pages);
      return pageRange.slice(0, 5)

    },
    paginationComponentStatus() {
      return !this.infinityLoading;

    }
  },
  methods: {
    range(start, stop, step = 1) {
      return Array(Math.ceil((stop - start) / step)).fill(start).map((x, y) => x + y * step)
    },
    setCurrentPage() {
      const routePage = this.$route.query.page;
      if (routePage !== undefined && !isNaN(parseInt(routePage))) {
        this.currentPage = parseInt(routePage);
      }
    },

  },
  watch: {
    '$route'(to, from) {
      this.setCurrentPage();
    },
    currentPage(value, oldValue) {
      if (this.enableScrollTopOnPageChange) {
        window.scrollTo({top: 0, behavior: 'smooth'});
      }
      this.onChangePage(value);
    }
  },
  mounted() {
    this.setCurrentPage();


  }
}
</script>

<style scoped>

</style>